// src/pages/admin/Dashboard.jsx — V3 bouton produit visible
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Routes, Route, NavLink, useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { useAuthStore } from '../../context/store';
import toast from 'react-hot-toast';

const NAV = [
  { to: '/admin',              icon: '⊞', label: 'Tableau de bord', end: true },
  { to: '/admin/commandes',    icon: '🛒', label: 'Commandes' },
  { to: '/admin/produits',     icon: '👗', label: 'Produits' },
  { to: '/admin/whatsapp',     icon: '💬', label: 'WhatsApp' },
  { to: '/admin/marketing',    icon: '📣', label: 'Marketing' },
  { to: '/admin/comptabilite', icon: '💰', label: 'Comptabilité' },
  { to: '/admin/clients',      icon: '👥', label: 'Clients' },
];

const C = {
  prune:'#4A1942',pruneL:'#6B2E62',pruneD:'#2D0F28',
  or:'#C9A84C',orL:'#E4C97A',
  creme:'#FDF6EC',cremeD:'#F5E8D3',cremeMid:'#EDD9BB',
  noir:'#1A0F18',gris:'#5C4A58',grisM:'#8B7A86',grisL:'#C4B8C0',
  vert:'#27AE60',rouge:'#C0392B',wa:'#25D366',
};

function Sidebar({ collapsed, setCollapsed }) {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  return (
    <aside style={{ width: collapsed?64:220, minHeight:'100vh', background:C.pruneD, display:'flex', flexDirection:'column', flexShrink:0, transition:'width .25s', overflow:'hidden', position:'sticky', top:0, height:'100vh' }}>
      <div style={{ padding:'20px 16px', borderBottom:'1px solid rgba(201,168,76,.15)', display:'flex', alignItems:'center', gap:10, minHeight:64 }}>
        <div style={{ width:32, height:32, background:`linear-gradient(135deg,${C.prune},${C.pruneL})`, borderRadius:6, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, fontFamily:'Georgia,serif', fontWeight:600, color:C.or, fontSize:13, border:'1px solid rgba(201,168,76,.3)' }}>FL</div>
        {!collapsed && <span style={{ color:C.creme, fontFamily:'Georgia,serif', fontSize:13, letterSpacing:'.15em', fontWeight:300, whiteSpace:'nowrap' }}>FABI LUXE</span>}
      </div>
      <nav style={{ flex:1, padding:'12px 8px', display:'flex', flexDirection:'column', gap:2, overflowY:'auto' }}>
        {NAV.map(n => (
          <NavLink key={n.to} to={n.to} end={n.end} style={({ isActive }) => ({
            display:'flex', alignItems:'center', gap:10, padding:'9px 10px',
            borderRadius:8, textDecoration:'none', whiteSpace:'nowrap', overflow:'hidden',
            color: isActive?C.or:'rgba(253,246,236,.6)',
            background: isActive?'rgba(201,168,76,.12)':'transparent',
            fontSize:13, transition:'all .15s',
            border: isActive?`1px solid rgba(201,168,76,.2)`:'1px solid transparent',
          })}>
            <span style={{ fontSize:16, flexShrink:0 }}>{n.icon}</span>
            {!collapsed && <span>{n.label}</span>}
          </NavLink>
        ))}
      </nav>
      <div style={{ padding:'12px 8px', borderTop:'1px solid rgba(201,168,76,.15)', display:'flex', flexDirection:'column', gap:6 }}>
        {!collapsed && (
          <div style={{ padding:'8px 10px', borderRadius:8, background:'rgba(201,168,76,.08)', border:'1px solid rgba(201,168,76,.12)' }}>
            <div style={{ fontSize:12, fontWeight:500, color:C.creme, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{user?.nom}</div>
            <div style={{ fontSize:11, color:C.or, marginTop:2, fontFamily:'monospace' }}>{user?.role}</div>
          </div>
        )}
        <button onClick={() => { logout(); navigate('/connexion'); }} style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 10px', borderRadius:8, color:'rgba(253,246,236,.5)', fontSize:13, background:'none', border:'none', cursor:'pointer' }}>
          <span style={{ fontSize:16, flexShrink:0 }}>🚪</span>
          {!collapsed && <span>Déconnexion</span>}
        </button>
        <button onClick={() => setCollapsed(c=>!c)} style={{ display:'flex', alignItems:'center', justifyContent:collapsed?'center':'flex-start', gap:10, padding:'8px 10px', borderRadius:8, color:'rgba(201,168,76,.5)', fontSize:13, background:'none', border:'none', cursor:'pointer' }}>
          <span>{collapsed?'→':'←'}</span>
          {!collapsed && <span style={{ fontSize:12 }}>Réduire</span>}
        </button>
      </div>
    </aside>
  );
}

export default function Dashboard() {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div style={{ display:'flex', minHeight:'100vh', background:C.creme, paddingTop:0 }}>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <main style={{ flex:1, overflow:'auto', minWidth:0, paddingTop:72 }}>
        <Routes>
          <Route index element={<DashHome />} />
          <Route path="commandes" element={<AdminOrders />} />
          <Route path="produits" element={<AdminProducts />} />
          <Route path="whatsapp" element={<AdminWhatsApp />} />
          <Route path="marketing" element={<AdminMarketing />} />
          <Route path="comptabilite" element={<AdminAccounting />} />
          <Route path="clients" element={<AdminClients />} />
        </Routes>
      </main>
    </div>
  );
}

function PageHeader({ title, subtitle, action }) {
  return (
    <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:28, flexWrap:'wrap', gap:16 }}>
      <div>
        <h1 style={{ fontFamily:'Georgia, serif', fontWeight:300, fontSize:28, color:C.pruneD, margin:0 }}>{title}</h1>
        {subtitle && <p style={{ color:C.grisM, fontSize:13, marginTop:4 }}>{subtitle}</p>}
      </div>
      {action && <div style={{ flexShrink:0 }}>{action}</div>}
    </div>
  );
}

function Card({ children, style={} }) {
  return <div style={{ background:'white', borderRadius:14, border:`1px solid ${C.cremeD}`, padding:'20px 24px', ...style }}>{children}</div>;
}

function KpiCard({ label, value, icon, color, sub, trend }) {
  return (
    <div style={{ background:'white', borderRadius:14, border:`1px solid ${C.cremeD}`, padding:'18px 20px' }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12 }}>
        <span style={{ fontSize:11, color:C.grisM, textTransform:'uppercase', letterSpacing:'.08em', fontFamily:'monospace' }}>{label}</span>
        <div style={{ width:38, height:38, borderRadius:10, background:(color||C.prune)+'15', display:'flex', alignItems:'center', justifyContent:'center', fontSize:18 }}>{icon}</div>
      </div>
      <div style={{ fontSize:24, fontWeight:500, color:C.pruneD, fontFamily:'Georgia, serif', lineHeight:1 }}>{value}</div>
      {(sub||trend!==undefined) && (
        <div style={{ display:'flex', alignItems:'center', gap:6, marginTop:8 }}>
          {trend!==undefined && <span style={{ fontSize:11, color:trend>=0?C.vert:C.rouge, fontFamily:'monospace' }}>{trend>=0?'↑':'↓'} {Math.abs(trend)}%</span>}
          {sub && <span style={{ fontSize:12, color:C.grisL }}>{sub}</span>}
        </div>
      )}
    </div>
  );
}

function StatusBadge({ statut }) {
  const map = {
    attente:{color:'#E67E22',bg:'#FEF3E2',label:'Attente'},
    confirme:{color:'#2980B9',bg:'#EBF5FB',label:'Confirmé'},
    preparation:{color:'#8E44AD',bg:'#F5EEF8',label:'Préparation'},
    expedie:{color:'#1ABC9C',bg:'#E8F8F5',label:'Expédié'},
    livre:{color:C.vert,bg:'#EAFAF1',label:'Livré'},
    annule:{color:C.rouge,bg:'#FDEDEC',label:'Annulé'},
  };
  const s = map[statut]||{color:C.grisM,bg:C.cremeD,label:statut};
  return <span style={{ background:s.bg, color:s.color, fontSize:11, fontWeight:500, padding:'3px 9px', borderRadius:20, fontFamily:'monospace', whiteSpace:'nowrap' }}>{s.label}</span>;
}

function Btn({ onClick, children, variant='primary', small, disabled, style:sx={} }) {
  const base = { display:'inline-flex', alignItems:'center', gap:6, padding:small?'7px 14px':'10px 20px', borderRadius:8, fontSize:small?12:13, fontWeight:600, cursor:disabled?'not-allowed':'pointer', opacity:disabled?0.5:1, border:'none', transition:'all .15s', fontFamily:'DM Sans, sans-serif' };
  const variants = {
    primary:  { background:`linear-gradient(135deg,${C.prune},${C.pruneL})`, color:C.or, boxShadow:`0 4px 16px rgba(74,25,66,.3)` },
    secondary:{ background:C.creme, color:C.noir, border:`1px solid ${C.cremeD}` },
    danger:   { background:'#FDEDEC', color:C.rouge, border:'1px solid #FADBD8' },
    success:  { background:'#EAFAF1', color:C.vert, border:'1px solid #A9DFBF' },
    wa:       { background:C.wa, color:'white' },
  };
  return <button onClick={onClick} disabled={disabled} style={{ ...base, ...variants[variant], ...sx }}>{children}</button>;
}

function TableWrap({ children }) {
  return <div style={{ overflowX:'auto' }}><table style={{ width:'100%', borderCollapse:'collapse', fontSize:13, minWidth:600 }}>{children}</table></div>;
}
const Th = ({ children }) => <th style={{ padding:'10px 14px', background:C.cremeD, color:C.grisM, fontWeight:500, textAlign:'left', fontSize:11, fontFamily:'monospace', textTransform:'uppercase', letterSpacing:'.06em', whiteSpace:'nowrap' }}>{children}</th>;
const Td = ({ children, style:sx={} }) => <td style={{ padding:'12px 14px', borderBottom:`1px solid ${C.creme}`, color:C.noir, verticalAlign:'middle', ...sx }}>{children}</td>;

function Spinner() {
  return <div style={{ display:'flex', justifyContent:'center', padding:48 }}><div style={{ width:32, height:32, border:`2px solid ${C.cremeD}`, borderTopColor:C.prune, borderRadius:'50%', animation:'spin .8s linear infinite' }} /></div>;
}

function Input({ value, onChange, placeholder, type='text', style:sx={} }) {
  return <input type={type} value={value} onChange={onChange} placeholder={placeholder} style={{ padding:'9px 14px', border:`1.5px solid ${C.cremeD}`, borderRadius:8, fontSize:13, background:'white', color:C.noir, outline:'none', fontFamily:'DM Sans, sans-serif', ...sx }} />;
}

function Select({ value, onChange, children, style:sx={} }) {
  return <select value={value} onChange={onChange} style={{ padding:'9px 14px', border:`1.5px solid ${C.cremeD}`, borderRadius:8, fontSize:13, background:'white', color:C.noir, outline:'none', fontFamily:'DM Sans, sans-serif', cursor:'pointer', ...sx }}>{children}</select>;
}

function fcfa(n) { if(n==null||isNaN(n)) return '— FCFA'; return Math.round(n).toLocaleString('fr-FR')+' FCFA'; }
function dateF(d) { if(!d) return '—'; return new Date(d).toLocaleDateString('fr-FR',{day:'2-digit',month:'2-digit',year:'2-digit'}); }
function nomMois(m) { return ['Jan','Fév','Mar','Avr','Mai','Jun','Jul','Aoû','Sep','Oct','Nov','Déc'][m-1]||''; }

function DashHome() {
  const [stats,setStats]=useState(null);
  const [orders,setOrders]=useState([]);
  const [loading,setLoading]=useState(true);
  useEffect(()=>{
    Promise.all([api.get('/accounting/dashboard'),api.get('/orders?limit=8')])
      .then(([s,o])=>{ setStats(s.data); setOrders(o.data.orders||[]); })
      .catch(()=>toast.error('Erreur chargement'))
      .finally(()=>setLoading(false));
  },[]);
  if(loading) return <div style={{padding:32}}><Spinner/></div>;
  const s=stats?.summary||{};
  const mtn=stats?.par_methode?.mtn||{};
  const orange=stats?.par_methode?.orange||{};
  const periode=stats?.periode||{};
  const benefice=(s.recettes||0)-(s.charges||0);
  return (
    <div style={{padding:32}}>
      <PageHeader title="Tableau de bord" subtitle={nomMois(periode.mois)+' '+periode.annee}
        action={<div style={{display:'flex',gap:8}}>
          <Btn variant="secondary" small onClick={()=>window.open('/api/accounting/export/excel','_blank')}>📊 Excel</Btn>
          <Btn variant="secondary" small onClick={()=>window.open('/api/accounting/export/pdf','_blank')}>📄 PDF</Btn>
        </div>}
      />
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(160px,1fr))',gap:14,marginBottom:24}}>
        <KpiCard label="Chiffre d'affaires" value={fcfa(s.recettes)} icon="💰" color={C.or} sub="ce mois"/>
        <KpiCard label="Bénéfice net" value={fcfa(benefice)} icon="📈" color={C.vert} trend={12}/>
        <KpiCard label="MTN Money" value={fcfa(mtn.total)} icon="📱" color="#FFCC00" sub={(mtn.nb||0)+' tx'}/>
        <KpiCard label="Orange Money" value={fcfa(orange.total)} icon="📱" color="#FF6600" sub={(orange.nb||0)+' tx'}/>
        <KpiCard label="Commandes" value={stats?.stats?.commandes_livrees||0} icon="🛒" color={C.prune}/>
        <KpiCard label="Clients actifs" value={stats?.stats?.clients_actifs||0} icon="👥" color={C.pruneL}/>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 300px',gap:16,marginBottom:20}}>
        <Card>
          <h2 style={{fontFamily:'Georgia,serif',fontWeight:300,fontSize:20,color:C.pruneD,margin:'0 0 16px'}}>CA par catégorie</h2>
          {(stats?.ca_par_categorie||[]).length===0?(
            <p style={{color:C.grisL,textAlign:'center',padding:24,fontStyle:'italic'}}>Aucune vente enregistrée</p>
          ):(stats?.ca_par_categorie||[]).map((c,i)=>{
            const max=stats.ca_par_categorie[0]?.ca||1;
            const pct=Math.round((c.ca/max)*100);
            const colors=[C.prune,C.pruneL,C.or,'#2980B9',C.vert,'#E67E22'];
            return(
              <div key={i} style={{marginBottom:12}}>
                <div style={{display:'flex',justifyContent:'space-between',fontSize:12,marginBottom:4}}>
                  <span style={{color:C.noir,fontWeight:500,textTransform:'capitalize'}}>{c.categorie}</span>
                  <span style={{color:C.grisM,fontFamily:'monospace'}}>{fcfa(c.ca)}</span>
                </div>
                <div style={{height:7,background:C.cremeD,borderRadius:4}}>
                  <div style={{height:'100%',width:pct+'%',background:colors[i%colors.length],borderRadius:4,transition:'width .5s'}}/>
                </div>
              </div>
            );
          })}
        </Card>
        <Card>
          <h2 style={{fontFamily:'Georgia,serif',fontWeight:300,fontSize:20,color:C.pruneD,margin:'0 0 16px'}}>Résumé</h2>
          {[
            {label:'Recettes',value:s.recettes,color:C.vert},
            {label:'Charges',value:s.charges,color:C.rouge},
            {label:'Bénéfice',value:benefice,color:C.prune,bold:true},
            {label:'TVA 18%',value:Math.round(benefice*0.18),color:'#E67E22'},
          ].map((r,i)=>(
            <div key={i} style={{display:'flex',justifyContent:'space-between',padding:'10px 0',borderBottom:i<3?`1px solid ${C.creme}`:'none'}}>
              <span style={{fontSize:13,color:C.grisM,fontWeight:r.bold?600:400}}>{r.label}</span>
              <span style={{fontSize:14,fontWeight:r.bold?700:500,color:r.color,fontFamily:'monospace'}}>{fcfa(r.value||0)}</span>
            </div>
          ))}
        </Card>
      </div>
      <Card style={{padding:0}}>
        <div style={{padding:'14px 20px',borderBottom:`1px solid ${C.creme}`,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <span style={{fontWeight:600,fontSize:14,color:C.pruneD}}>Dernières commandes</span>
          <Btn variant="secondary" small onClick={()=>window.location.href='/admin/commandes'}>Voir toutes →</Btn>
        </div>
        <TableWrap>
          <thead><tr><Th>Référence</Th><Th>Client</Th><Th>Total</Th><Th>Statut</Th><Th>Date</Th></tr></thead>
          <tbody>
            {orders.map(o=>(
              <tr key={o.id}>
                <Td><span style={{fontFamily:'monospace',fontSize:11,color:C.prune,fontWeight:600}}>{o.ref}</span></Td>
                <Td style={{fontWeight:500}}>{o.client_nom}</Td>
                <Td style={{fontWeight:600}}>{fcfa(o.total)}</Td>
                <Td><StatusBadge statut={o.statut}/></Td>
                <Td style={{color:C.grisL,fontSize:11}}>{dateF(o.created_at)}</Td>
              </tr>
            ))}
            {orders.length===0&&<tr><td colSpan={5} style={{padding:32,textAlign:'center',color:C.grisL,fontStyle:'italic'}}>Aucune commande</td></tr>}
          </tbody>
        </TableWrap>
      </Card>
    </div>
  );
}

function AdminOrders() {
  const [orders,setOrders]=useState([]);
  const [loading,setLoading]=useState(true);
  const [filtre,setFiltre]=useState('');
  const load=useCallback(()=>{
    setLoading(true);
    const p=new URLSearchParams({limit:50});
    if(filtre) p.set('statut',filtre);
    api.get('/orders?'+p).then(r=>setOrders(r.data.orders||[])).finally(()=>setLoading(false));
  },[filtre]);
  useEffect(()=>{load();},[load]);
  const updateStatus=async(orderId,statut)=>{
    try{await api.patch('/orders/'+orderId+'/status',{statut});toast.success('Statut → '+statut);load();}
    catch{toast.error('Erreur');}
  };
  return(
    <div style={{padding:32}}>
      <PageHeader title="Commandes" subtitle={orders.length+' commandes'}/>
      <div style={{display:'flex',gap:8,marginBottom:20,flexWrap:'wrap'}}>
        {['','attente','confirme','preparation','expedie','livre','annule'].map(s=>(
          <button key={s} onClick={()=>setFiltre(s)}
            style={{padding:'6px 14px',borderRadius:20,fontSize:12,border:`1px solid ${filtre===s?C.prune:C.cremeD}`,background:filtre===s?C.prune:'white',color:filtre===s?C.or:C.grisM,cursor:'pointer',fontFamily:'monospace',transition:'all .15s'}}>
            {s||'Toutes'}
          </button>
        ))}
      </div>
      <Card style={{padding:0}}>
        {loading?<Spinner/>:(
          <TableWrap>
            <thead><tr><Th>Réf.</Th><Th>Client</Th><Th>Téléphone</Th><Th>Total</Th><Th>Livraison</Th><Th>Statut</Th><Th>Date</Th><Th>Actions</Th></tr></thead>
            <tbody>
              {orders.map(o=>(
                <tr key={o.id}>
                  <Td><span style={{fontFamily:'monospace',fontSize:11,color:C.prune,fontWeight:600}}>{o.ref}</span></Td>
                  <Td style={{fontWeight:500}}>{o.client_nom}</Td>
                  <Td style={{color:C.grisM,fontSize:12}}>{o.client_phone}</Td>
                  <Td style={{fontWeight:600}}>{fcfa(o.total)}</Td>
                  <Td style={{fontSize:11,color:C.grisM,fontFamily:'monospace'}}>{o.livraison_type}</Td>
                  <Td><StatusBadge statut={o.statut}/></Td>
                  <Td style={{color:C.grisL,fontSize:11}}>{dateF(o.created_at)}</Td>
                  <Td>
                    <div style={{display:'flex',gap:4}}>
                      <select onChange={e=>e.target.value&&updateStatus(o.id,e.target.value)} defaultValue=""
                        style={{padding:'4px 8px',border:`1px solid ${C.cremeD}`,borderRadius:6,fontSize:11,cursor:'pointer',color:C.grisM}}>
                        <option value="">Changer...</option>
                        {['confirme','preparation','expedie','livre','annule'].map(s=><option key={s} value={s}>{s}</option>)}
                      </select>
                      {o.client_phone&&(
                        <a href={'https://wa.me/'+o.client_phone.replace(/\D/g,'')} target="_blank" rel="noreferrer">
                          <Btn variant="wa" small>💬</Btn>
                        </a>
                      )}
                    </div>
                  </Td>
                </tr>
              ))}
              {orders.length===0&&<tr><td colSpan={8} style={{padding:32,textAlign:'center',color:C.grisL,fontStyle:'italic'}}>Aucune commande</td></tr>}
            </tbody>
          </TableWrap>
        )}
      </Card>
    </div>
  );
}

function AdminProducts() {
  const [products,setProducts]=useState([]);
  const [loading,setLoading]=useState(true);
  const [search,setSearch]=useState('');
  const [cat,setCat]=useState('');
  const [showForm,setShowForm]=useState(false);
  const [editProduct,setEditProduct]=useState(null);

  const load=useCallback(()=>{
    setLoading(true);
    const p=new URLSearchParams({limit:100});
    if(search) p.set('q',search);
    if(cat) p.set('categorie',cat);
    api.get('/products?'+p).then(r=>setProducts(r.data.products||[])).finally(()=>setLoading(false));
  },[search,cat]);

  useEffect(()=>{const t=setTimeout(load,300);return()=>clearTimeout(t);},[load]);

  const toggleActif=async(id,current)=>{
    await api.put('/products/'+id,{actif:!current});
    toast.success(current?'Désactivé':'Activé');
    load();
  };

  return(
    <div style={{padding:32}}>
      <PageHeader title="Produits" subtitle={products.length+' produits'}
        action={
          <Btn onClick={()=>{setEditProduct(null);setShowForm(true);}}>
            ✨ Nouveau produit
          </Btn>
        }
      />
      <div style={{display:'flex',gap:12,marginBottom:20,flexWrap:'wrap'}}>
        <Input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Rechercher..." style={{flex:1,minWidth:200}}/>
        <Select value={cat} onChange={e=>setCat(e.target.value)}>
          <option value="">Toutes catégories</option>
          {['wax','bazin','boubou','moderne','accessoires','enfants'].map(c=><option key={c} value={c}>{c}</option>)}
        </Select>
      </div>
      <Card style={{padding:0}}>
        {loading?<Spinner/>:(
          <TableWrap>
            <thead><tr><Th>Produit</Th><Th>Catégorie</Th><Th>Prix</Th><Th>Promo</Th><Th>Stock</Th><Th>Actif</Th><Th>Actions</Th></tr></thead>
            <tbody>
              {products.map(p=>(
                <tr key={p.id}>
                  <Td>
                    <div style={{fontWeight:500,color:C.pruneD,maxWidth:220}}>{p.nom}</div>
                    {p.description&&<div style={{fontSize:11,color:C.grisL,marginTop:2,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',maxWidth:220}}>{p.description}</div>}
                  </Td>
                  <Td><span style={{background:C.cremeD,color:C.prune,fontSize:11,padding:'2px 9px',borderRadius:20,fontFamily:'monospace',fontWeight:500}}>{p.categorie}</span></Td>
                  <Td style={{fontFamily:'monospace',fontSize:12,fontWeight:600,color:C.pruneD}}>{fcfa(p.prix)}</Td>
                  <Td style={{fontFamily:'monospace',fontSize:12,color:p.prix_promo?C.vert:C.grisL}}>{p.prix_promo?fcfa(p.prix_promo):'—'}</Td>
                  <Td><span style={{fontWeight:700,color:p.stock===0?C.rouge:p.stock<5?'#E67E22':C.vert}}>{p.stock}</span></Td>
                  <Td>
                    <button onClick={()=>toggleActif(p.id,p.actif)}
                      style={{width:38,height:21,borderRadius:11,background:p.actif?C.vert:C.cremeD,border:'none',cursor:'pointer',position:'relative',transition:'background .2s'}}>
                      <div style={{width:15,height:15,borderRadius:'50%',background:'white',position:'absolute',top:3,left:p.actif?20:3,transition:'left .2s',boxShadow:'0 1px 3px rgba(0,0,0,.2)'}}/>
                    </button>
                  </Td>
                  <Td>
                    <div style={{display:'flex',gap:4}}>
                      <Btn variant="secondary" small onClick={()=>{setEditProduct(p);setShowForm(true);}}>✏️ Modifier</Btn>
                      <Btn variant="danger" small onClick={()=>{if(window.confirm('Désactiver ?')) toggleActif(p.id,true);}}>🗑</Btn>
                    </div>
                  </Td>
                </tr>
              ))}
              {products.length===0&&(
                <tr><td colSpan={7} style={{padding:40,textAlign:'center'}}>
                  <div style={{color:C.grisL,fontStyle:'italic',fontSize:14,marginBottom:16}}>Aucun produit — commencez par en créer un !</div>
                  <Btn onClick={()=>{setEditProduct(null);setShowForm(true);}}>✨ Créer mon premier produit</Btn>
                </td></tr>
              )}
            </tbody>
          </TableWrap>
        )}
      </Card>
      {showForm&&<ProductFormModal onClose={()=>{setShowForm(false);setEditProduct(null);}} onSave={()=>{setShowForm(false);setEditProduct(null);load();}} product={editProduct}/>}
    </div>
  );
}

function ProductFormModal({ onClose, onSave, product=null }) {
  const isEdit=!!product;
  const [form,setForm]=useState({
    nom:product?.nom||'',
    prix:product?.prix||'',
    prix_promo:product?.prix_promo||'',
    categorie:product?.categorie||'wax',
    stock:product?.stock??'',
    description:product?.description||'',
    tailles:product?.tailles?(Array.isArray(product.tailles)?product.tailles.join(','):product.tailles):'S,M,L,XL,XXL',
    couleurs:product?.couleurs?(Array.isArray(product.couleurs)?product.couleurs.map(c=>c.nom+':'+c.hex).join('|'):''):'',
  });
  const [saving,setSaving]=useState(false);
  const set=k=>e=>setForm(f=>({...f,[k]:e.target.value}));
  const taillesPreview=form.tailles.split(',').map(t=>t.trim()).filter(Boolean);
  const couleursPreview=form.couleurs.split('|').filter(Boolean).map(c=>{
    const[nom,hex]=c.split(':');
    return{nom:nom?.trim(),hex:hex?.trim()};
  }).filter(c=>c.nom&&c.hex);

  const save=async()=>{
    if(!form.nom||!form.prix) return toast.error('Nom et prix obligatoires');
    setSaving(true);
    try{
      const payload={
        nom:form.nom.trim(),
        prix:parseInt(form.prix),
        prix_promo:form.prix_promo?parseInt(form.prix_promo):null,
        categorie:form.categorie,
        stock:parseInt(form.stock||0),
        description:form.description.trim()||null,
        tailles:JSON.stringify(taillesPreview),
        couleurs:JSON.stringify(couleursPreview),
      };
      if(isEdit){
        await api.put('/products/'+product.id,payload);
        toast.success('Produit mis à jour !');
      }else{
        await api.post('/products',payload);
        toast.success('Produit créé !');
      }
      onSave();
    }catch(e){toast.error(e.response?.data?.message||'Erreur');}
    finally{setSaving(false);}
  };

  const inp={width:'100%',padding:'10px 14px',border:`1.5px solid ${C.cremeD}`,borderRadius:8,fontSize:13,fontFamily:'DM Sans,sans-serif',outline:'none',boxSizing:'border-box',color:C.noir};
  const lbl={display:'block',fontSize:11,color:C.grisM,marginBottom:6,textTransform:'uppercase',letterSpacing:'.08em',fontFamily:'monospace'};

  return(
    <div style={{position:'fixed',inset:0,background:'rgba(45,15,40,.65)',zIndex:200,display:'flex',alignItems:'center',justifyContent:'center',padding:24,overflowY:'auto'}}>
      <div style={{background:'white',borderRadius:20,padding:32,width:'100%',maxWidth:620,boxShadow:`0 24px 80px rgba(74,25,66,.3)`,maxHeight:'90vh',overflowY:'auto'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:28}}>
          <div>
            <h2 style={{fontFamily:'Georgia,serif',fontWeight:300,fontSize:26,color:C.pruneD,margin:0}}>{isEdit?'✏️ Modifier':'✨ Nouveau produit'}</h2>
            <p style={{fontSize:12,color:C.grisM,marginTop:6}}>Les champs * sont obligatoires</p>
          </div>
          <button onClick={onClose} style={{background:C.creme,border:'none',cursor:'pointer',width:32,height:32,borderRadius:'50%',fontSize:16,color:C.grisM,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>✕</button>
        </div>
        <div style={{display:'flex',flexDirection:'column',gap:18}}>
          <div>
            <label style={lbl}>Nom du produit *</label>
            <input value={form.nom} onChange={set('nom')} placeholder="Ex: Robe Wax Dorée Premium" style={inp}/>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            <div>
              <label style={lbl}>Prix de vente (FCFA) *</label>
              <input type="number" value={form.prix} onChange={set('prix')} placeholder="45000" style={inp} min="100"/>
              </div>
            <div>
              <label style={lbl}>Prix promotionnel (FCFA)</label>
              <input type="number" value={form.prix_promo} onChange={set('prix_promo')} placeholder="Optionnel" style={inp} min="0"/>
              {form.prix&&form.prix_promo&&parseInt(form.prix_promo)<parseInt(form.prix)&&(
                <p style={{fontSize:11,color:C.vert,marginTop:4}}>Réduction : {Math.round((1-form.prix_promo/form.prix)*100)}%</p>
              )}
            </div>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            <div>
              <label style={lbl}>Catégorie *</label>
              <select value={form.categorie} onChange={set('categorie')} style={{...inp,cursor:'pointer'}}>
                {[['wax','🌺 Wax'],['bazin','✨ Bazin'],['boubou','👘 Boubou'],['moderne','🎽 Moderne'],['accessoires','👜 Accessoires'],['enfants','🧒 Enfants']].map(([v,l])=>(
                  <option key={v} value={v}>{l}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={lbl}>Stock disponible</label>
              <input type="number" value={form.stock} onChange={set('stock')} placeholder="0" style={inp} min="0"/>
              {form.stock!==''&&parseInt(form.stock)===0&&<p style={{fontSize:11,color:C.rouge,marginTop:4}}>⚠ Affiché comme épuisé</p>}
            </div>
          </div>
          <div>
            <label style={lbl}>Tailles disponibles (séparées par virgules)</label>
            <input value={form.tailles} onChange={set('tailles')} placeholder="S,M,L,XL,XXL" style={inp}/>
            <div style={{display:'flex',gap:6,flexWrap:'wrap',marginTop:8}}>
              {taillesPreview.map((t,i)=>(
                <span key={i} style={{padding:'3px 12px',background:C.cremeD,color:C.prune,borderRadius:20,fontSize:11,fontFamily:'monospace',fontWeight:600}}>{t}</span>
              ))}
            </div>
          </div>
          <div>
            <label style={lbl}>Couleurs (Nom:#hexcode séparés par |)</label>
            <input value={form.couleurs} onChange={set('couleurs')} placeholder="Or:#C9A84C|Bleu:#1C3A6B|Rouge:#800020" style={inp}/>
            {couleursPreview.length>0&&(
              <div style={{display:'flex',gap:10,flexWrap:'wrap',marginTop:10,alignItems:'center'}}>
                {couleursPreview.map((c,i)=>(
                  <div key={i} style={{display:'flex',alignItems:'center',gap:6,background:C.creme,padding:'4px 10px',borderRadius:20,border:`1px solid ${C.cremeD}`}}>
                    <div style={{width:16,height:16,borderRadius:'50%',background:c.hex,border:'2px solid rgba(0,0,0,.15)',flexShrink:0}}/>
                    <span style={{fontSize:12,color:C.gris}}>{c.nom}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div>
            <label style={lbl}>Description du produit</label>
            <textarea value={form.description} onChange={set('description')} rows={3}
              placeholder="Matière, style, occasion, entretien..."
              style={{...inp,resize:'vertical',lineHeight:1.7}}/>
          </div>
        </div>
        <div style={{display:'flex',gap:12,marginTop:24,justifyContent:'flex-end',paddingTop:20,borderTop:`1px solid ${C.cremeD}`}}>
          <button onClick={onClose} style={{padding:'10px 22px',background:C.creme,color:C.grisM,border:`1px solid ${C.cremeD}`,borderRadius:8,fontSize:13,fontWeight:500,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>Annuler</button>
          <button onClick={save} disabled={saving} style={{padding:'10px 28px',background:saving?C.grisL:`linear-gradient(135deg,${C.prune},${C.pruneL})`,color:C.or,border:'none',borderRadius:8,fontSize:13,fontWeight:600,cursor:saving?'not-allowed':'pointer',fontFamily:'DM Sans,sans-serif',boxShadow:saving?'none':'0 4px 16px rgba(74,25,66,.3)'}}>
            {saving?'⏳ Enregistrement...':isEdit?'✅ Mettre à jour':'✨ Créer le produit'}
          </button>
        </div>
      </div>
    </div>
  );
}

function AdminWhatsApp() {
  const [convs,setConvs]=useState([]);
  const [active,setActive]=useState(null);
  const [msgs,setMsgs]=useState([]);
  const [text,setText]=useState('');
  const msgsEndRef=useRef(null);
  useEffect(()=>{api.get('/whatsapp/conversations').then(r=>setConvs(r.data.conversations||[])).catch(()=>{});},[]);
  useEffect(()=>{
    if(!active) return;
    api.get('/whatsapp/conversations/'+active.client_phone).then(r=>setMsgs(r.data.messages||[]));
  },[active]);
  useEffect(()=>{msgsEndRef.current?.scrollIntoView({behavior:'smooth'});},[msgs]);
  const send=async()=>{
    if(!text.trim()||!active) return;
    try{await api.post('/whatsapp/send',{phone:active.client_phone,message:text});setText('');api.get('/whatsapp/conversations/'+active.client_phone).then(r=>setMsgs(r.data.messages||[]));}
    catch{toast.error('Erreur envoi');}
  };
  return(
    <div style={{padding:32}}>
      <PageHeader title="WhatsApp Business" subtitle="Messagerie clients"/>
      <Card style={{padding:0,display:'grid',gridTemplateColumns:'280px 1fr',minHeight:500}}>
        <div style={{borderRight:`1px solid ${C.creme}`,overflow:'auto',maxHeight:600}}>
          <div style={{padding:'12px 16px',borderBottom:`1px solid ${C.creme}`,background:C.cremeD}}>
            <span style={{fontSize:11,color:C.grisM,fontFamily:'monospace',textTransform:'uppercase',letterSpacing:'.06em'}}>Conversations</span>
          </div>
          {convs.length===0?(
            <p style={{padding:24,color:C.grisL,fontSize:13,textAlign:'center',fontStyle:'italic'}}>Aucun message</p>
          ):convs.map(c=>(
            <div key={c.client_phone} onClick={()=>setActive(c)}
              style={{padding:'12px 16px',cursor:'pointer',borderBottom:`1px solid ${C.creme}`,background:active?.client_phone===c.client_phone?'#F5EEF8':'white',borderLeft:active?.client_phone===c.client_phone?`3px solid ${C.prune}`:'3px solid transparent'}}>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:3}}>
                <span style={{fontWeight:600,fontSize:13,color:C.pruneD}}>{c.client_phone}</span>
                {c.non_lus>0&&<span style={{background:C.prune,color:C.or,borderRadius:10,fontSize:10,padding:'1px 7px',fontWeight:600}}>{c.non_lus}</span>}
              </div>
              <p style={{fontSize:12,color:C.grisL,margin:0,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{c.derniere_msg}</p>
            </div>
          ))}
        </div>
        {active?(
          <div style={{display:'flex',flexDirection:'column'}}>
            <div style={{padding:'12px 20px',borderBottom:`1px solid ${C.creme}`,background:C.cremeD}}>
              <div style={{fontWeight:600,fontSize:14,color:C.pruneD}}>{active.client_phone}</div>
            </div>
            <div style={{flex:1,overflow:'auto',padding:'16px 20px',display:'flex',flexDirection:'column',gap:8,maxHeight:420,background:C.creme}}>
              {msgs.map((m,i)=>(
                <div key={i} style={{display:'flex',justifyContent:m.direction==='out'?'flex-end':'flex-start'}}>
                  <div style={{maxWidth:'72%',padding:'9px 14px',borderRadius:m.direction==='out'?'14px 14px 3px 14px':'14px 14px 14px 3px',background:m.direction==='out'?`linear-gradient(135deg,${C.prune},${C.pruneL})`:'white',color:m.direction==='out'?C.creme:C.noir,fontSize:13}}>
                    <p style={{margin:0,lineHeight:1.5}}>{m.message}</p>
                  </div>
                </div>
              ))}
              <div ref={msgsEndRef}/>
            </div>
            <div style={{padding:'12px 16px',borderTop:`1px solid ${C.cremeD}`,display:'flex',gap:10,background:'white'}}>
              <input value={text} onChange={e=>setText(e.target.value)} onKeyDown={e=>e.key==='Enter'&&send()} placeholder="Écrire un message..."
                style={{flex:1,padding:'10px 16px',border:`1.5px solid ${C.cremeD}`,borderRadius:24,fontSize:13,fontFamily:'DM Sans,sans-serif',outline:'none',color:C.noir}}/>
              <button onClick={send} style={{width:42,height:42,borderRadius:'50%',background:`linear-gradient(135deg,${C.prune},${C.pruneL})`,border:'none',cursor:'pointer',color:C.or,fontSize:18,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>→</button>
            </div>
          </div>
        ):(
          <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',color:C.grisL,padding:40,gap:16}}>
            <span style={{fontSize:56}}>💬</span>
            <p style={{fontSize:15,fontFamily:'Georgia,serif',fontStyle:'italic'}}>Sélectionnez une conversation</p>
          </div>
        )}
      </Card>
    </div>
  );
}

function AdminMarketing() {
  const [campaigns,setCampaigns]=useState([]);
  const [vouchers,setVouchers]=useState([]);
  const [tab,setTab]=useState('campagnes');
  useEffect(()=>{
    api.get('/marketing/campaigns').then(r=>setCampaigns(r.data.campaigns||[])).catch(()=>{});
    api.get('/marketing/vouchers').then(r=>setVouchers(r.data.vouchers||[])).catch(()=>{});
  },[]);
  return(
    <div style={{padding:32}}>
      <PageHeader title="Marketing" subtitle="Campagnes et codes promo"/>
      <div style={{display:'flex',gap:0,marginBottom:20,borderBottom:`1px solid ${C.cremeD}`}}>
        {[['campagnes','📣 Campagnes'],['promo','🏷 Codes promo']].map(([id,label])=>(
          <button key={id} onClick={()=>setTab(id)}
            style={{padding:'10px 20px',border:'none',background:'none',cursor:'pointer',fontSize:13,fontWeight:500,color:tab===id?C.pruneD:C.grisM,borderBottom:tab===id?`2px solid ${C.prune}`:'2px solid transparent',marginBottom:-1,fontFamily:'DM Sans,sans-serif'}}>
            {label}
          </button>
        ))}
      </div>
      {tab==='campagnes'&&(
        <Card style={{padding:0}}>
          <TableWrap>
            <thead><tr><Th>Nom</Th><Th>Canal</Th><Th>Envoyés</Th><Th>Statut</Th><Th>Date</Th></tr></thead>
            <tbody>
              {campaigns.map(c=>(<tr key={c.id}><Td style={{fontWeight:500}}>{c.nom}</Td><Td><span style={{fontSize:11,background:C.cremeD,padding:'2px 9px',borderRadius:20,fontFamily:'monospace',color:C.prune}}>{c.canal}</span></Td><Td style={{fontFamily:'monospace',fontSize:12}}>{c.envoyes||0}</Td><Td><StatusBadge statut={c.statut==='termine'?'livre':'attente'}/></Td><Td style={{color:C.grisL,fontSize:11}}>{dateF(c.created_at)}</Td></tr>))}
              {campaigns.length===0&&<tr><td colSpan={5} style={{padding:32,textAlign:'center',color:C.grisL,fontStyle:'italic'}}>Aucune campagne</td></tr>}
            </tbody>
          </TableWrap>
        </Card>
      )}
      {tab==='promo'&&(
        <Card style={{padding:0}}>
          <TableWrap>
            <thead><tr><Th>Code</Th><Th>Réduction</Th><Th>Type</Th><Th>Utilisations</Th></tr></thead>
            <tbody>
              {vouchers.map(v=>(<tr key={v.id}><Td><span style={{fontFamily:'monospace',fontSize:12,background:C.cremeD,padding:'2px 10px',borderRadius:4,color:C.prune,fontWeight:600}}>{v.code}</span></Td><Td style={{fontWeight:700,color:C.vert}}>{v.type==='pourcentage'?v.reduction+'%':fcfa(v.reduction)}</Td><Td style={{fontSize:11,color:C.grisM}}>{v.type}</Td><Td style={{fontFamily:'monospace',fontSize:12}}>{v.utilisations}</Td></tr>))}
              {vouchers.length===0&&<tr><td colSpan={4} style={{padding:32,textAlign:'center',color:C.grisL,fontStyle:'italic'}}>Aucun code promo</td></tr>}
            </tbody>
          </TableWrap>
        </Card>
      )}
    </div>
  );
}

function AdminAccounting() {
  const [data,setData]=useState(null);
  const [month,setMonth]=useState(new Date().getMonth()+1);
  const [year,setYear]=useState(new Date().getFullYear());
  useEffect(()=>{api.get('/accounting/dashboard?mois='+month+'&annee='+year).then(r=>setData(r.data)).catch(()=>{});},[month,year]);
  const s=data?.summary||{};
  const benefice=(s.recettes||0)-(s.charges||0);
  const tva=Math.round(benefice*0.18);
  return(
    <div style={{padding:32}}>
      <PageHeader title="Comptabilité" subtitle="Bilans financiers"
        action={<div style={{display:'flex',gap:8}}>
          <Select value={month} onChange={e=>setMonth(parseInt(e.target.value))}>
            {Array.from({length:12},(_,i)=><option key={i+1} value={i+1}>{nomMois(i+1)}</option>)}
          </Select>
          <Select value={year} onChange={e=>setYear(parseInt(e.target.value))}>
            {[2024,2025,2026].map(y=><option key={y} value={y}>{y}</option>)}
          </Select>
        </div>}
      />
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(160px,1fr))',gap:14,marginBottom:24}}>
        <KpiCard label="Recettes" value={fcfa(s.recettes)} icon="📈" color={C.vert}/>
        <KpiCard label="Charges" value={fcfa(s.charges)} icon="📉" color={C.rouge}/>
        <KpiCard label="Bénéfice net" value={fcfa(benefice)} icon="💰" color={C.or}/>
        <KpiCard label="TVA 18% CI" value={fcfa(tva)} icon="🧾" color={C.prune}/>
      </div>
      <Card>
        <h2 style={{fontFamily:'Georgia,serif',fontWeight:300,fontSize:20,color:C.pruneD,margin:'0 0 20px'}}>Bilan {nomMois(month)} {year}</h2>
        {[
          {label:"Chiffre d'affaires",value:s.recettes,color:C.vert},
          {label:'Charges',value:-(s.charges||0),color:C.rouge},
          {label:'Bénéfice avant TVA',value:benefice,bold:true},
          {label:'TVA 18% CI',value:-tva,color:'#E67E22'},
          {label:'Résultat net',value:benefice-tva,bold:true,highlight:true},
        ].map((row,i)=>(
          <div key={i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 16px',background:row.highlight?'#F5EEF8':i%2===0?'white':C.creme,borderRadius:8,marginBottom:2}}>
            <span style={{fontSize:13,color:C.grisM,fontWeight:row.bold?600:400}}>{row.label}</span>
            <span style={{fontSize:14,fontWeight:row.bold?700:500,fontFamily:'monospace',color:row.highlight?C.prune:(row.value||0)<0?C.rouge:C.vert}}>
              {(row.value||0)<0?'-':''}{fcfa(Math.abs(row.value||0))}
            </span>
          </div>
        ))}
        <div style={{display:'flex',gap:10,marginTop:20,flexWrap:'wrap'}}>
          {[
            {label:'📊 Journal Excel',url:'/api/accounting/export/excel'},
            {label:'📄 Bilan PDF',url:'/api/accounting/export/pdf?mois='+month+'&annee='+year},
          ].map(e=><Btn key={e.label} variant="secondary" onClick={()=>window.open(e.url,'_blank')}>{e.label}</Btn>)}
        </div>
      </Card>
    </div>
  );
}

function AdminClients() {
  const [clients,setClients]=useState([]);
  const [loading,setLoading]=useState(true);
  useEffect(()=>{
    api.get('/orders?limit=200').then(r=>{
      const users={};
      (r.data.orders||[]).forEach(o=>{
        if(!users[o.client_phone||o.client_nom]) users[o.client_phone||o.client_nom]={nom:o.client_nom,phone:o.client_phone,commandes:0,total:0};
        users[o.client_phone||o.client_nom].commandes++;
        users[o.client_phone||o.client_nom].total+=parseInt(o.total||0);
      });
      setClients(Object.values(users).sort((a,b)=>b.total-a.total));
    }).finally(()=>setLoading(false));
  },[]);
  return(
    <div style={{padding:32}}>
      <PageHeader title="Clients" subtitle={clients.length+' clients'}/>
      <Card style={{padding:0}}>
        {loading?<Spinner/>:(
          <TableWrap>
            <thead><tr><Th>#</Th><Th>Nom</Th><Th>Téléphone</Th><Th>Commandes</Th><Th>Total achats</Th><Th>Actions</Th></tr></thead>
            <tbody>
              {clients.map((c,i)=>(
                <tr key={i}>
                  <Td style={{color:C.grisL,fontFamily:'monospace',fontSize:11}}>{i+1}</Td>
                  <Td style={{fontWeight:500,color:C.pruneD}}>{c.nom}</Td>
                  <Td style={{fontFamily:'monospace',fontSize:12}}>{c.phone||'—'}</Td>
                  <Td><span style={{background:C.cremeD,color:C.prune,padding:'2px 10px',borderRadius:20,fontSize:12,fontFamily:'monospace',fontWeight:600}}>{c.commandes}</span></Td>
                  <Td style={{fontFamily:'monospace',fontSize:12,fontWeight:600,color:C.vert}}>{fcfa(c.total)}</Td>
                  <Td>{c.phone&&(<a href={'https://wa.me/'+c.phone.replace(/\D/g,'')} target="_blank" rel="noreferrer"><Btn variant="wa" small>💬 WhatsApp</Btn></a>)}</Td>
                </tr>
              ))}
              {clients.length===0&&<tr><td colSpan={6} style={{padding:32,textAlign:'center',color:C.grisL,fontStyle:'italic'}}>Aucun client</td></tr>}
            </tbody>
          </TableWrap>
        )}
      </Card>
    </div>
  );
}
